module.exports = __webpack_public_path__ + "static/notebook-billing-creative-49376123c84ed81ae25efc7e576429e0.png";